import React from "react";
import Table from "../../Common/Table";

import TableFields from "../../../constants/TelecallerLeads/TableFields.json";

const TelecallerLeadsList = (props) => {
  const { list, handleViewClick, callStatuses = [] } = props;

  const getCallStatusVal = (val) => {
    const filteredResults = callStatuses.filter((item) => item.status === val);
    if (filteredResults.length > 0) {
      return filteredResults[0]["statusDisplay"];
    } else {
      return "";
    }
  };

  const getFieldValue = (item, key) => {
    switch (key) {
      case "callStatus":
        return getCallStatusVal(item[key]);
      case "actions":
        return (
          <span
            onClick={() => handleViewClick(item)}
            className="edit-options cursor-pointer"
          >
            Edit
          </span>
        );
      default:
        return item[key];
    }
  };

  return (
    <Table list={list} getFieldValue={getFieldValue} fields={TableFields} />
  );
};

export default TelecallerLeadsList;
